import { FormItem as FormItemBase, FormItemComponentProps, OtherKeys } from 'react-antd-formutil';
import classlist from 'utils/classlist';
import './style.scss';

/**
 * 针对 antd formItem 修改其下面的input select样式
 * line: boolean;  默认为true，即底部线框模式
 */
const FormItem: React.FC<FormItemComponentProps<any, any, any> & OtherKeys & { line?: boolean }> = ({
    line = true,
    children,
    className,
    ...rest
}) => {
    return (
        <FormItemBase className={classlist(line ? 'comp-form-item' : '', className)} {...rest}>
            {children}
        </FormItemBase>
    );
};

export default FormItem;
